import Faq from 'entities/Faq';
import Collection from 'lib/Collection';

// @ts-expect-error ts-migrate(2417) FIXME: Class static side 'typeof Faqs' incorrectly extend... Remove this comment to see the full error message
export default class Faqs extends Collection<Faq> {
  initialize() {
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof Faq' is missing the following propert... Remove this comment to see the full error message
    this.model = Faq;
  }

  parse(response: any) {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'article' implicitly has an 'any' type.
    return response.map((article) => Faq.fromJSON(article));
  }

  // $FlowFixMe
  static fetch(query: string, locale = 'en-US'): Promise<Faqs> {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'Promise<Faqs | Collection<Faq>>' is not assi... Remove this comment to see the full error message
    return Faq.searchFaqs(query, locale).then((response) => this.fromJSON(response));
  }
}
